export enum Order {
	Ascending = 1, Descending = 2
}